import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M2 12.1V8.447L9.331 3.9H13.7a.281.281 0 0 1 .3.28v7.92H9.412v-1.363a.736.736 0 0 1 .316-.633l3.612-2.161a.194.194 0 0 0 .106-.188.223.223 0 0 0-.223-.222h-3.81L2.067 12.1Z';
const draw24px =
  'M1.938,18.882V12.75l12.3-7.632H21.57a.471.471,0,0,1,.492.472V18.882H14.37l.006-2.287a1.234,1.234,0,0,1,.531-1.062L20.96,11.9a.326.326,0,0,0,.177-.314.373.373,0,0,0-.374-.374H14.37L2.046,18.882Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoAutodeskIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoAutodesk'),
) as IconWithRender;

LogoAutodeskIcon.displayName = 'LogoAutodeskIcon';
LogoAutodeskIcon.propTypes = Icon.propTypes;
LogoAutodeskIcon.renderIcon = (props) => <LogoAutodeskIcon {...props} />;
export default LogoAutodeskIcon;
